import React from "react";
import { IconButton, Slider, Stack } from "@mui/material";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import PauseCircleIcon from "@mui/icons-material/PauseCircle";

const Player = ({
  currentTick,
  maxTicks,
  onTickChange,
}: {
  currentTick: number;
  maxTicks: number;
  onTickChange: (value: number) => void;
}) => {
  const [isPlaying, setIsPlaying] = React.useState(false);

  React.useEffect(() => {
    if (isPlaying) {
      const interval = setInterval(() => {
        const tickSize = 100 / maxTicks;
        const nextTick = Math.round(currentTick + tickSize);
        const isLastTick = nextTick >= 100;

        onTickChange(isLastTick ? 0 : nextTick);
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [isPlaying, onTickChange, currentTick]);

  const handleChange = (_: Event, value: number | number[]) => {
    onTickChange(value as number);
    setIsPlaying(false);
  };

  return (
    <Stack direction="row" spacing={1.25} role="player" alignItems="center">
      <IconButton
        size="small"
        aria-label={isPlaying ? "Pause" : "Play"}
        onClick={() => setIsPlaying(!isPlaying)}
      >
        {isPlaying ? (
          <PauseCircleIcon fontSize="large" color="primary" />
        ) : (
          <PlayCircleIcon fontSize="large" color="primary" />
        )}
      </IconButton>
      <Slider aria-label="Volume" value={currentTick} onChange={handleChange} />
    </Stack>
  );
};

export default Player;
